import { Button } from '../../../../../../../../../components/Toolkit/Button';
import { Link } from '../../../../../../../../../components/Toolkit/Button/Link';
import { Text } from '../../../../../../../../../components/ToolkitV2/Text/Text';
import { Spacer } from '../../../../../../../../../helpers/genericStyles';
import { Guide } from '../../../subcomponents/Guide/Guide';
import { VehicleDetails } from '../../../subcomponents/VehicleDetails/VehicleDetails';
import { Loading } from '../../../../../../../../../components/Toolkit/Loading/Loading';
import { Notification } from '../../../../../../../../../components/Toolkit/Notification/Notification';
import { ActionsFooter } from '../../../subcomponents/ActionsFooter/ActionsFooter';

import { useValuationDetails } from './ValuationDetails.hook';
import { useCarValuationToolContext } from '../../../../CarValuationTool.context';

import { formatValuation, formatVehicleDetails } from '../../../../formatting';

import getConfig from 'next/config';
import { PrivateValuation } from '../../../../queries/schema/PrivateValuationSchema';
import { Container } from '../../../subcomponents/Container/Container.styled';

const ValuationDetails = (props: { carValuationData: PrivateValuation }) => {
  const {
    carValuationData: {
      vehicleDetails,
      expectedDealerOfferRange,
      privateMarketOfferRange,
    },
  } = props;

  const {
    publicRuntimeConfig: { CDN_STATIC_ASSETS },
  } = getConfig();

  const {
    onClickSave,
    valuationDate,
    reset,
    isErrorSavingUserVehicle,
    isPending,
  } = useValuationDetails({
    vehicleDetails,
  });

  const { resetCarValuationForm } = useCarValuationToolContext();

  return (
    <>
      {!isErrorSavingUserVehicle && (
        <Container>
          <div>
            <VehicleDetails
              name={`${vehicleDetails.make} ${vehicleDetails.model} ${vehicleDetails.yearOfManufacture}`}
              details={formatVehicleDetails(vehicleDetails)}
            />
            <Spacer marginBottom="M24" />
            <Guide
              header="Trade-in sale guide"
              body={formatValuation(expectedDealerOfferRange)}
              backgroundColor="BLUE_LIGHTER"
              footer={valuationDate}
            />
            <Spacer marginBottom="S12" />
            <Guide
              header="Private sale guide"
              body={formatValuation(privateMarketOfferRange)}
              backgroundColor="GREY_LIGHTER"
              footer={valuationDate}
            />
            <Spacer marginBottom="M24" />
            <Text>
              Car valuations are based on live and historic listings for
              guidance purposes only. While every effort is made to ensure
              accuracy, valuations may not reflect current market conditions.
              Please refer to live listings for the most up-to-date pricing.{' '}
              <Link
                inline
                href="https://www.donedeal.ie/value-my-car"
                target="_blank"
              >
                Learn more about our car valuation tool.
              </Link>
            </Text>
            <Spacer marginBottom="M24" />
          </div>
          <ActionsFooter>
            <Button ofType="SECONDARY" onClick={resetCarValuationForm}>
              Back
            </Button>
            <Button
              onClick={onClickSave}
              disabled={isPending}
              data-tracking="cvonadp-save-to-profile"
            >
              {isPending ? (
                <Loading cdnUrl={CDN_STATIC_ASSETS} />
              ) : (
                'Save to my profile'
              )}
            </Button>
          </ActionsFooter>
        </Container>
      )}
      {isErrorSavingUserVehicle && (
        <Container>
          <Notification intent="ERROR">
            <Text size="M16" color="GREY_DARKER">
              There was a problem processing your request - please try again.
            </Text>
          </Notification>
          <Button ofType="SECONDARY" onClick={reset}>
            Try again
          </Button>
        </Container>
      )}
    </>
  );
};

export { ValuationDetails };
